import { createFileRoute } from '@tanstack/react-router';

import { SignInRedirect } from '../features/auth/sign-in-redirect.js';

export const Route = createFileRoute('/login')({
  component: SignInRedirect,
});
